var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSocFormG(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.6888 12.8664H30.4V12.8H16V19.2H25.0424C23.7232 22.9256 20.1784 25.6 16 25.6C10.6984 25.6 6.4 21.3016 6.4 16C6.4 10.6984 10.6984 6.4 16 6.4C18.4472 6.4 20.6736 7.3232 22.3688 8.8312L26.8944 4.3056C24.0368 1.6424 20.2144 0 16 0C7.164 0 0 7.164 0 16C0 24.836 7.164 32 16 32C24.836 32 32 24.836 32 16C32 14.9272 31.8896 13.88 31.6888 12.8664Z",
    fill: "#FFC107"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.8457 8.5528L7.1025 12.408C8.5249 8.8864 11.9697 6.4 16.0009 6.4C18.4481 6.4 20.6745 7.3232 22.3697 8.8312L26.8953 4.3056C24.0377 1.6424 20.2153 0 16.0009 0C9.8553 0 4.5257 3.4696 1.8457 8.5528Z",
    fill: "#FF3D00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9999 32.0009C20.1327 32.0009 23.8879 30.4193 26.7271 27.8473L21.7751 23.6569C20.1147 24.9197 18.0858 25.6026 15.9999 25.6009C11.8383 25.6009 8.30466 22.9473 6.97346 19.2441L1.75586 23.2641C4.40386 28.4457 9.78146 32.0009 15.9999 32.0009Z",
    fill: "#4CAF50"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6888 12.8652L31.6647 12.7988L16 12.7988V19.1988H25.0424C24.4114 20.972 23.2747 22.5214 21.7728 23.6556L21.7752 23.654L26.7272 27.8444C26.3768 28.1628 32 23.9988 32 15.9988C32 14.926 31.8896 13.8788 31.6888 12.8652Z",
    fill: "#1976D2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocFormG);
export default __webpack_public_path__ + "static/media/soc-form-g.8798998accabda72c6dddb9a30dbf4c3.svg";
export { ForwardRef as ReactComponent };